import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { CalloutAlert, HelpTip } from '@massds/mayflower-react';
import { toCurrencynodec, toNumber } from '../../utils';
import outputProps from '../../data/output.json';
import variables from '../../data/variables.json';


const Output = (props) => {
  const {
    refundPercent 
  } = variables;
  const {
    line1, line2, line3, line4, line5, line6, dataKey
  } = props;

  const outputContent = outputProps[dataKey];

  const totTaxLiability = toNumber(line1) - toNumber(line2) - toNumber(line3) - toNumber(line4) - toNumber(line5) - toNumber(line6)
  const totTaxLiabilityRounded = Math.round(totTaxLiability * refundPercent)
  const qualified = (totTaxLiabilityRounded) > 0;

  const helptipIframeProp = {};
  if (process.env.REACT_APP_IFRAME === 'true') {
    helptipIframeProp.bypassMobileStyle = true;
  }

  return(
    <Fragment>
      {
      qualified ? (
        <CalloutAlert theme="c-primary" icon={null}>
          { outputContent.qualified.textBefore }
          <strong> {toCurrencynodec(totTaxLiabilityRounded)}</strong>
          { outputContent.qualified.textAfter }
          <div className="ma__disclaimer">{outputContent.qualified.disclaimer}</div>
        </CalloutAlert>
      ) : (
        <CalloutAlert theme="c-error-red" icon={null}>
          <HelpTip
            theme="c-white"
            {...outputContent.disqualified}
            {...helptipIframeProp}
          >
          </HelpTip>
        </CalloutAlert>
      )
    }
    </Fragment>
  );
};

Output.propTypes = {
  line1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  line2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  line3: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  line4: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  line5: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),  
  line6: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),  
  refundPercent: PropTypes.string
};

export default Output;
